import styled from 'styled-components';

export const FieldError = styled.span.attrs({
    className: 'field-error',
})`
    display: block;
    margin-top: 0.5rem;
    color: red;
`;

export const LanguageText = styled.span`
    display: block;
    margin-top: 1rem;
    color: #0094f9;
    cursor: pointer;
`;
